import React from 'react'

export const DropdownButton = (props: { onClick?: React.MouseEventHandler; children?: React.ReactNode }) => {
  return (
    <button onClick={props.onClick} className="generic-dropdown-button">
      {props.children}
    </button>
  )
}
